import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { CustomerService } from "./customer.service";
import { ContractWeb, ContractClient, FuelClient, WebContractLetter, WebContractLetterLocal, WebContractAgreement } from "src/app/models";
import { WebCompany } from "src/app/models";
import { CompanyService } from "./company.service";
import { LocationListService } from "./location-list.service";
import { ContractWebLocal } from "src/app/models/contract-web-local";
import { filter } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class ContractsService
{

    private company: WebCompany;

    private branchCustId: string;

    public contractWeb: ContractWeb[] = [];

    public webContractLetters: WebContractLetter[] = [];

    // ContractWeb is for WebHub, WebContract is for mobile builds.
    // Nate made ContractWeb class in RCCI to include location for WebHub 7/6/20
    private contractSubject = new BehaviorSubject<ContractWebLocal[]>([]);
    public contract: Observable<ContractWebLocal[]> = this.contractSubject.asObservable();

    private contractLetterSubject = new BehaviorSubject<WebContractLetterLocal[]>([]);
    public contractLetter: Observable<WebContractLetterLocal[]> = this.contractLetterSubject.asObservable();

    private contractTermsSubject = new BehaviorSubject<string>("");
    public contractTerms: Observable<string> = this.contractTermsSubject.asObservable();

    private prebuySwitchSubject = new BehaviorSubject<boolean>(null);
    public prebuySwitch: Observable<boolean> = this.prebuySwitchSubject.asObservable();

    constructor(
        private contractClient: ContractClient,
        private customerService: CustomerService,
        private fuelClient: FuelClient,
        private companyService: CompanyService,
        private locationService: LocationListService
    )
    {
        this.customerService.customer
            .pipe(filter(customer => !!customer))
            .subscribe(customer =>
            {
                this.branchCustId = customer.BranchCustId;
                this.getContractList();
                this.getContractLetters();
                this.getContractLetterSignup();
            });

        this.companyService.company.subscribe(c =>
        {
            this.company = c;
        });

        this.locationService.locationList.subscribe(l =>
        {
            this.populateContractDesc();
            this.populateContractLettersDesc();
        });
    }

    private populateContractDesc()
    {
        if (this.contractWeb?.length > 0)
        {
            const contractItems: ContractWebLocal[] = this.contractWeb.map(c =>
            {
                return { LocationUsageDesc: this.locationService.getLocationDesc(c.Loc), ...c };
            });
            this.contractSubject.next(contractItems);
        }
    }

    private populateContractLettersDesc()
    {
        if (this.webContractLetters?.length > 0)
        {
            const contractLetterItems: WebContractLetterLocal[] = this.webContractLetters.map(c =>
            {
                return { LocationUsageDesc: this.locationService.getLocationDesc(c.Location), ...c };
            });
            this.contractLetterSubject.next(contractLetterItems);
        }
    }

    public getContractList()
    {
        this.contractClient.getContractsByCustomerWeb(this.branchCustId)
            .subscribe(c =>
            {
                this.contractSubject.next(c);
                this.contractWeb = c;
                this.populateContractDesc();
            });
    }

    public getContractLetters()
    { // getContractLettersByIdWeb
        this.contractClient.getContractLettersByIdWeb(this.branchCustId)
            .subscribe(c =>
            {
                this.webContractLetters = c;
                this.contractLetterSubject.next(c);
                this.populateContractLettersDesc();
            });
    }

    /** writeContractLetter will send a confirmation email if email is provided (not whitespace)
     *  Used for customers that paid with acct credit and didn't go through pmt process.
     *  Error using parameters that can be null in RCCMobile. so use "" instead of null.
     */
    public writeContractLetter(agreement: WebContractAgreement): void
    {

        // if future me wants to send multiple objects as params, must be wrapped
        this.contractClient.writeContractLetter(agreement)
            .subscribe(_ =>
            {
                this.getContractList();
                this.getContractLetters();

            });
    }

    /**
     * This method gets state of prebuy option- FuelTableCnf15Result.ContractLetterSignupAvailable.
     * if true, prebuy option will be shown on menu. Else prebuy option is removed.
     */
    public getContractLetterSignup(): void
    {
        this.fuelClient.getContractLetterSignup().subscribe(r => this.prebuySwitchSubject.next(r));
    }
}
